<template>
  <div id="cards1">
    <dv-border-box-11 :titleWidth="145" title="智能烘房" class="catdsBox">
      <div class="boxBorder">
        <div
          class="card-item"
          v-for="(item, index) in dryingRoom"
          :key="item.id"
        >
          <div class="card-header">
            <div class="card-header-left">{{ item.title }}</div>
            <div class="card-header-right">{{ item.id }}号</div>
          </div>
          <div class="activeChart">
            <dv-charts class="ring-charts" :option="item.ring2" />
            <dv-charts class="ring-charts" :option="item.ring" />
            <div class="wenshidu">
              <div
                :class="`${wenduRingValue27 > 75 ? 'wenduRing' : ''}`"
                v-show="index === 0"
              >
                <i class="iconfont icon-wenshidu-"></i>
                {{ wenduRingValue27 }}°C
              </div>
              <div
                :class="`${wenduRingValue38 > 75 ? 'wenduRing' : ''}`"
                v-show="index === 1"
              >
                <i class="iconfont icon-wenshidu-"></i>
                {{ wenduRingValue38 }}°C
              </div>
            </div>
            <i class="iconfont icon-shidu"></i>
          </div>
          <div class="card-footer">
            <div class="card-footer-item">
              <div class="footer-title">
                <span>电能消耗</span>
                <i class="iconfont icon-dianchi-zhongdianliang"></i>
              </div>
              <div class="footer-detail">
                <dv-digital-flop
                  :config="item.total"
                  style="width: 70%; height: 35px"
                />
                <div class="detail">W</div>
              </div>
            </div>
            <div class="card-footer-item">
              <div class="footer-title">
                工作时长
                <i class="iconfont icon-shijian"></i>
              </div>
              <div class="footer-detail">
                <dv-digital-flop
                  :config="item.num"
                  style="width: 70%; height: 35px"
                />
                <div class="detail">天</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dv-border-box-11>
    <dv-border-box-10 class="dvBorderBox10">
      <div class="messageWar">
        <div class="messageTop">
          <i class="messageStyle iconfont icon-xiaoxi1"></i>
          <div :class="`${messageTrud ? 'messageRed' : ''}`"></div>
        </div>
        <dv-scroll-board
          :config="messageData"
          style="width: 100%; height: 40px"
        />
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import testDryingRoom from '../../assets/json/dryingRoom.json'
export default {
  name: 'dryingRoom',
  data() {
    return {
      dryingRoom: [],
      wenduRingValue27: null,
      wenduRingValue38: null,
      messageTrud: true,
      messageData: {
        data: [
          ['您收到了新消息，尽快查收', '4月17日 10:18'],
          ['您收到了新消息，尽快查收', '4月16日 12:58'],
          ['您收到了新消息，尽快查收', '4月15日 11:00'],
          ['您收到了新消息，尽快查收', '4月14日 10:28'],
          ['您收到了新消息，尽快查收', '4月13日 14:39'],
          ['您收到了新消息，尽快查收', '4月12日 16:26'],
          ['您收到了新消息，尽快查收', '4月11日 15:38']
        ],
        columnWidth: [210, 110],
        waitTime: 7000,
        oddRowBGC: 'rgba(255, 255, 255, 0)',
        evenRowBGC: 'rgba(255, 255, 255, 0)',
        rowNum: 1
      }
    }
  },
  mounted() {
    const { createData } = this
    createData()
    setInterval(this.createData, 30000)
  },
  methods: {
    createData() {
      const { randomExtend } = this
      this.dryingRoom = [
        {
          id: 1,
          title: '注引烘干房',
          total: {
            number: [randomExtend(1513, 1513)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 28
            }
          },
          num: {
            number: [randomExtend(20, 20)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 28
            }
          },
          ring2: {
            title: {
              text: ''
            },
            series: [
              {
                type: 'gauge',
                arcLineWidth: 13,
                radius: '85%',
                data: [
                  {
                    name: 'itemA',
                    value: randomExtend(50, 50.8),
                    gradient: ['#4dabf7', '#69db7c', '#ffa94d', '#fe464f'],
                    localGradient: true
                  }
                ],
                axisLabel: {
                  formatter: '{value}',
                  fontSize: 20,
                  style: {
                    fill: '#fff',
                    fontSize: 12,
                    fontWeight: 'bold'
                  }
                }
              }
            ]
          },
          ring: {
            series: [
              {
                type: 'gauge',
                startAngle: -Math.PI / 2,
                endAngle: Math.PI * 1.5,
                arcLineWidth: 13,
                radius: '80%',
                data: [
                  {
                    name: '湿度',
                    value: randomExtend(49.9, 50.3),
                    gradient: ['#03c2fd', '#1ed3e5', '#2fded6']
                  }
                ],
                axisLabel: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                pointer: {
                  show: false
                },
                backgroundArc: {
                  style: {
                    stroke: '#224590'
                  }
                },
                details: {
                  show: true,
                  formatter: '湿度{value}%',
                  style: {
                    fill: '#1ed3e5',
                    fontSize: 20
                  }
                }
              }
            ],
            color: ['#1ed3e5']
          }
        },
        {
          id: 2,
          title: '注引烘干房',
          total: {
            number: [randomExtend(1540, 1500)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#26fcd8',
              fontWeight: 'bold',
              fontSize: 28
            }
          },
          num: {
            number: [randomExtend(16, 16)],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold',
              fontSize: 28
            }
          },
          ring2: {
            title: {
              text: ''
            },
            series: [
              {
                type: 'gauge',
                arcLineWidth: 13,
                radius: '85%',
                data: [
                  {
                    name: 'itemA',
                    value: randomExtend(52, 52.6),
                    gradient: ['#4dabf7', '#69db7c', '#ffa94d', '#fe464f'],
                    localGradient: true
                  }
                ],
                axisLabel: {
                  formatter: '{value}',
                  fontSize: 20,
                  style: {
                    fill: '#fff',
                    fontSize: 12,
                    fontWeight: 'bold'
                  }
                }
              }
            ]
          },
          ring: {
            series: [
              {
                type: 'gauge',
                startAngle: -Math.PI / 2,
                endAngle: Math.PI * 1.5,
                arcLineWidth: 13,
                radius: '80%',
                data: [
                  {
                    name: '湿度',
                    value: randomExtend(45.1, 45.5),
                    gradient: ['#03c2fd', '#1ed3e5', '#2fded6']
                  }
                ],
                axisLabel: {
                  show: false
                },
                axisTick: {
                  show: false
                },
                pointer: {
                  show: false
                },
                backgroundArc: {
                  style: {
                    stroke: '#224590'
                  }
                },
                details: {
                  show: true,
                  formatter: '湿度{value}%',
                  style: {
                    fill: '#1ed3e5',
                    fontSize: 20
                  }
                }
              }
            ],
            color: ['#1ed3e5']
          }
        }
      ]
      this.wenduRingValue27 = this.dryingRoom[0].ring2.series[0].data[0].value
      this.wenduRingValue38 = this.dryingRoom[1].ring2.series[0].data[0].value
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  }
}
</script>

<style lang="less" >
#cards1 {
  width: 19%;
  display: flex;
  flex-direction: column;
  .catdsBox {
    height: 92%;
    margin-top: -10px;
    padding-top: 50px;
    box-sizing: border-box;

    .boxBorder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      box-sizing: border-box;
      padding: 3px 10px;
      .card-item {
        background-color: rgba(6, 30, 93, 0.5);
        border-top: 2px solid rgba(1, 153, 209, 0.5);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 50%;
        .card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .card-header-left {
            font-size: 20px;
            font-weight: 800;
            padding-left: 20px;
          }

          .card-header-right {
            padding-right: 15px;
            font-size: 27px;
            font-weight: 700;
            color: #03d3ec;
          }
        }
        .activeChart {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;

          .wenshidu {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: absolute;
            top: 80%;
            left: 12%;
            font-size: 20px;
            font-weight: 700;
            color: #fff;
            .wenduRing {
              color: #ff0000;
              animation: blinker 1s linear infinite;
            }
            .icon-wenshidu- {
              font-size: 28px;
              font-weight: normal;
            }
          }

          .icon-shidu {
            position: absolute;
            top: 60%;
            left: 71%;
            font-size: 28px;
            color: #1ed3e5;
          }
        }
      }
    }
  }

  .ring-charts {
    width: 100%;
    height: 190px;
  }

  .card-footer {
    height: 25%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .card-footer-item {
    padding: 12px;
    box-sizing: border-box;
    width: 40%;
    background-color: rgba(6, 30, 93, 0.7);
    border-radius: 8px;
    .icon-dianchi-zhongdianliang {
      font-size: 24px;
      margin-left: 6px;
      margin-top: -5px;
    }
    .icon-shijian {
      font-size: 24px;
      margin-top: -5px;
    }
    .footer-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 17px;
      margin-bottom: 10px;
    }

    .footer-detail {
      font-size: 20px;
      color: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      .detail {
        font-size: 18px;
        margin-right: 4px;
      }

      .dv-digital-flop {
        margin-right: 5px;
      }
    }
  }
  .dvBorderBox10 {
    margin-top: 10px;
    height: 8%;
    box-sizing: border-box;
    .messageWar {
      height: 100%;
      padding-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .messageTop {
        position: relative;
        .messageStyle {
          font-size: 25px;
          font-weight: 700;
          color: #ff0000;
          animation: blinker 1s linear infinite;
        }
        .messageRed {
          position: absolute;
          top: 1%;
          right: 1%;
          width: 10px;
          height: 10px;
          border-radius: 50%;
        }
        @keyframes blinker {
          50% {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>
